import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function BlogCard({ post }) {
  const date = post.published_at
    ? new Date(post.published_at).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "";
  return (
    <Link
      to={`/blog/${post.slug}`}
      data-testid={`blog-card-${post.slug}`}
      className="group block bg-[#F8F5F0] border border-[#E5E0D8] overflow-hidden hover:border-[#C9A96E]/60 transition-colors"
    >
      <div className="aspect-[4/3] overflow-hidden bg-[#E5E0D8]">
        {post.cover_image ? (
          <img
            src={post.cover_image}
            alt={post.title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-[#0A0A0A] to-[#1A1A1A]" />
        )}
      </div>
      <div className="p-7">
        <div className="flex items-center justify-between mb-4">
          <span className="overline text-[#C9A96E]">{post.category}</span>
          <span className="text-xs text-[#6B7280]">{date}</span>
        </div>
        <h3 className="font-serif text-2xl md:text-3xl leading-tight text-[#1A1A1A] group-hover:text-[#C9A96E] transition-colors">
          {post.title}
        </h3>
        <p className="mt-4 text-sm text-[#6B7280] leading-relaxed line-clamp-3">
          {post.excerpt}
        </p>
        <div className="mt-6 inline-flex items-center gap-2 text-sm uppercase tracking-[0.18em] text-[#1A1A1A] group-hover:text-[#C9A96E]">
          Read More <ArrowUpRight size={14} />
        </div>
      </div>
    </Link>
  );
}
